export default {
  basketMessage: function (message) {
    $('#basket-message').append(`<p style="background-color: lightgreen; padding: 6px;">${message}</p>`)
    $('#basket-message p').delay(3000).fadeOut('slow')
    window.scrollTo(0, 0)
  },
  errorHandler: function (error) {
    $('#errors').append(`<p class="basket-flash-message" style="background-color: lightgoldenrodyellow">${error}</p>`)
    $('#errors p').delay(3000).fadeOut('slow')
    window.scrollTo(0, 0)
  },
  formError: function (error, permanent = false) {
    $('#errors').append(`<p class="basket-flash-message" style="background-color: #FFF0F0; padding: 6px;">${error}</p>`)

    if (!permanent) {
      $('#errors p').delay(10000).fadeOut('slow')
    }

    window.scrollTo(0, 0)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/alert.js